import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { Checkbox, Form, Input, InputGroup, InputPicker, Table, TagPicker, Uploader } from 'rsuite';
import CloseIcon from '@rsuite/icons/Close';
import Swal from 'sweetalert2';
import attachmentService from '../../../../services/Shared/attachment.service';
import LoadingSpinner from '../../../Shared/GenericComponents/LoadingSpinner';
import { sort_by } from '../../../Shared/HelperFunctions';

function EntityEnforcementAttachments(props) {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [bottomSortColumn, setBottomSortColumn] = useState("file");
    const [bottomSortType, setBottomSortType] = useState("asc");
    const [gridData, setGridData] = useState([]);
    const [checkedRows, setCheckedRows] = useState([]);
    const [docTypes, setDocTypes] = useState([]);
    const [selectedDocTypes, setSelectedDocTypes] = useState([]);
    const [fileNameFilter, setFileNameFilter] = useState('');

    useEffect(() => {
        if (props.activeKey == 'enforcementAttachments') {
            refreshBottomGrid()
            refreshGrid()
        }
    }, [props.activeKey])
    useEffect(() => {
        attachmentService.getEnforcementFilesForEntity(props.entityId).then((data) => {
            if (data.data.length > 0)
                props.setTabBoldness(true)
        })

    }, [])

    const handleBottomSortColumn = (sortColumn, sortType) => {
        setBottomSortColumn(sortColumn);
        setBottomSortType(sortType);
    }
    const refreshBottomGrid = () => {
        setHasLoaded(false)
        attachmentService.getEnforcementFilesForEntity(props.entityId).then((data) => {
            var temp = [];
            temp = data.data.map((tempData, index) => {
                return {
                    id: tempData.id,
                    laserficheId: tempData.laserficheId,
                    parentType: tempData.legacy ? 'Legacy' : tempData.parentType,
                    timestamp: tempData.uploadDate,
                    file: tempData.fileName,
                    attachmentType: tempData.documentType,
                    fileLink: ''
                };
            })
            if (temp.length > 0)
                props.setTabBoldness(true)
            else
                props.setTabBoldness(false)
            setHasLoaded(true)
            setGridData(temp)
            setDocTypes([...new Set(temp.map(a => a.attachmentType))].map((x, i) => { return { "label": `${x}`, "value": `${x}` } }).sort(sort_by('label')));
        })
    }
    const getBottomData = () => {
        var sortedData = gridData.sort(sort_by(bottomSortColumn, bottomSortType !== "asc"));
        if (selectedDocTypes?.length > 0) {
            sortedData = sortedData.filter((v, i) => {
                return selectedDocTypes.includes(v.attachmentType)
            })
        }
        if (fileNameFilter) {
            sortedData = sortedData.filter(v => v.file?.toLowerCase().includes(fileNameFilter.toLowerCase()));
        }
        return sortedData;
    }
    const handleCheckAll = (value, checked) => {
        const checkedKeys = checked ? getData().map(item => item.id) : [];
        setCheckedRows(checkedKeys)
    }
    const handleCheck = (value, checked) => {
        if (checked)
            setCheckedRows([...checkedRows, value])
        else
            setCheckedRows(checkedRows.filter(item => item !== value));
    }
    const downloadSelected = () => {
        Swal.fire({
            title: 'Downloading Files',
            didOpen: () => {
                Swal.showLoading();
                Promise.all(checkedRows.map((val) => {
                    return attachmentService.getFileData(val)
                })).then((values) => {
                    values.forEach((val, i) => {
                        setTimeout(() => {
                            var name = new String(val.headers['content-disposition']);
                            const downloadUrl = window.URL.createObjectURL(new Blob([val.data]));
                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            var fileName = name.slice(name.indexOf('filename=') + 9, name.lastIndexOf(';')).replace(/^["'](.+(?=["']$))["']$/, '$1');
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }, 200 * (i + 1))
                    })
                }).then(() => {
                    Swal.close();
                });
            },
            allowOutsideClick: false
        })
    }

    const docTypeChange = (val) => {
        setSelectedDocTypes(val);
        setCheckedRows([]);
    }

    const [attachmentTypes, setAttachmentTypes] = useState([]);
    const [attachmentType, setAttachmentType] = useState();
    const [isUploading, setIsUploading] = useState(false);
    const [attachmentTypeDropdown, setAttachmentTypeDropdown] = useState();
    const [sortColumn, setSortColumn] = useState("timestamp");
    const [sortType, setSortType] = useState("desc");
    const [hasUploaderLoaded, setHasUploaderLoaded] = useState(false);

    const attachmentTypeChange = (e) => {
        setAttachmentType(e);
        setAttachmentTypeDropdown(e);
    }
    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
    }
    const getData = () => {
        var sortedData = formData.filesForDisplay?.sort(sort_by(sortColumn, sortType !== "asc"));
        return sortedData;
    }
    useEffect(() => {
        attachmentService.getAllEnforcementDocTypes(props.isIndividual).then((data) => {
            setAttachmentTypes(data);
        });
    }, [])

    useEffect(() => { refreshGrid(); }
        , [attachmentTypes])

    useEffect(() => { refreshGrid(); }
        , [props.refreshData])

    const [formData, updateFormData] = useState({
        files: [],
        filesForDisplay: [],
        loading: false,
    });

    const refreshGrid = () => {
        setHasUploaderLoaded(false)
        updateFormData({
            ...formData,
            loading: true,
        })

        attachmentService.getFiles(props.entityId, 10).then((data) => {

            var attachmentTypeIds = attachmentTypes.map((attachmentType, index) => {
                return attachmentType.value;
            })
            var tempData = [];
            tempData = data?.data.filter(tempData => attachmentTypeIds.includes(tempData.documentTypeId)).map((tempData, index) => {
                return {
                    id: tempData.id,
                    timestamp: tempData.uploadDate,
                    file: tempData.fileName,
                    attachmentType: tempData.documentType,
                    fileLink: ''
                };
            })
            updateFormData({
                filesForDisplay: tempData,
                files: [],
                loading: false,
            })
            setHasUploaderLoaded(true)
        })
    }

    const deleteFile = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                attachmentService.deleteFile(id).then((response) => {
                    refreshGrid();
                    refreshBottomGrid();
                })
            }
        })
    }

    const handleChange = (val, e) => {
        setIsUploading(true);
        if (!e.entries().next().done) {
            updateFormData({
                ...formData,
                loading: true,
            })
            attachmentService.postFile(val, 10, props.entityId, attachmentType, props.entityId).then((response) => {
                setIsUploading(false);
                refreshGrid();
                refreshBottomGrid();
                if (attachmentTypes.length > 1) { // Only clear attachment type when there is a dropdown list of attachments on post
                    setAttachmentType("");
                    setAttachmentTypeDropdown("");
                }
            })
        }
    }
    return <>
        <Form>

            <Row>

                <Col sm="12">
                    <strong>File Upload&nbsp;</strong>
                </Col>

            </Row>
            {attachmentTypes.length > 1 &&
                <Row className="mt-2">
                    <Col sm={props.isIndividual !== undefined ? "12" : "4"}>
                        <Form.Control
                            accepter={InputPicker}
                            placeholder="Please Select"
                            block
                            data={attachmentTypes}
                            name="attachmentType"
                            onChange={attachmentTypeChange}
                            value={attachmentTypeDropdown} />
                    </Col>
                </Row>
            }
            {!isUploading ?
                <Row className="mt-2">
                    <Col sm="12">
                        <Form.Control
                            name="files"
                            accepter={Uploader}
                            listType="text"
                            onUpload={handleChange}
                            disabled={(!attachmentType)}
                            fileListVisible={false}
                            multiple
                            draggable
                            accept={attachmentService.ATTACHMENTTYPES}><div style={{ lineHeight: '200px' }}>Click or Drag files to this area to upload</div>
                        </Form.Control>
                    </Col>
                </Row>
                :
                <LoadingSpinner />
            }
            <Row>
                <Col sm="12">
                    <br />
                    {hasUploaderLoaded ?

                        <Table
                            onSortColumn={(sortColumn, sortType) => { handleSortColumn(sortColumn, sortType) }}
                            sortColumn={sortColumn}
                            sortType={sortType}
                            autoHeight
                            wordWrap
                            data={getData()}>

                            <Table.Column flexGrow={2} minWidth={125} sortable>
                                <Table.HeaderCell><b>File Name</b></Table.HeaderCell>
                                <Table.Cell dataKey="file">{(rowData) => (<a style={{ color: 'blue', cursor: 'pointer' }} onClick={() => { attachmentService.openFile(rowData.id) }}>{rowData.file}</a>)}</Table.Cell>
                            </Table.Column>
                            <Table.Column flexGrow={1} minWidth={75} sortable>
                                <Table.HeaderCell><b>Date Created</b></Table.HeaderCell>
                                <Table.Cell dataKey="timestamp">{(rowData) => (new Date(rowData.timestamp).toLocaleDateString())}</Table.Cell>
                            </Table.Column>
                            <Table.Column flexGrow={2} minWidth={125} sortable>
                                <Table.HeaderCell><b>Type</b></Table.HeaderCell>
                                <Table.Cell dataKey="attachmentType"></Table.Cell>
                            </Table.Column>
                            <Table.Column width={100}>
                                <Table.HeaderCell>Actions(s)</Table.HeaderCell>
                                <Table.Cell dataKey="id">{
                                    (rowData) => (<FaIcons.FaTrash onClick={() => { deleteFile(rowData.id) }} />)
                                }
                                </Table.Cell>
                            </Table.Column>
                        </Table>
                        :
                        <LoadingSpinner />
                    }
                </Col>
            </Row>
        </Form>
        <br />
        {hasLoaded ?
            <div>
                <Row className="my-2">
                    <Col>
                        <Button disabled={checkedRows?.length == 0} onClick={downloadSelected}>Download Selected</Button>
                    </Col>
                    <Col>
                        <Form>
                            <Form.Control
                                block
                                accepter={TagPicker}
                                data={docTypes}
                                name="docTypes"
                                placeholder="Filter on Doc Type"
                                onChange={docTypeChange} />
                        </Form>
                    </Col>
                    <Col>
                        <InputGroup>
                            <Input
                                placeholder="Filter on File Name"
                                value={fileNameFilter}
                                onChange={setFileNameFilter} />
                            {fileNameFilter &&
                                <InputGroup.Button onClick={() => setFileNameFilter('')}>
                                    <CloseIcon />
                                </InputGroup.Button>
                            }
                        </InputGroup>
                    </Col>
                </Row>
                <Table
                    onSortColumn={(bottomSortColumn, bottomSortType) => { handleBottomSortColumn(bottomSortColumn, bottomSortType) }}
                    sortColumn={bottomSortColumn}
                    sortType={bottomSortType}
                    autoHeight
                    wordWrap
                    data={getBottomData()}>
                    <Table.Column fixed width={50}>
                        <Table.HeaderCell>
                            <Checkbox
                                indeterminate={checkedRows?.length > 0 && checkedRows?.length != getBottomData()?.length}
                                onChange={handleCheckAll}
                                checked={checkedRows?.length == getBottomData()?.length}
                            /></Table.HeaderCell>
                        <Table.Cell dataKey="id">
                            {rowData => (
                                <Checkbox
                                    value={rowData["id"]}
                                    onChange={handleCheck}
                                    checked={checkedRows?.some(item => item === rowData["id"])} />
                            )}

                        </Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={1} minWidth={125} sortable>
                        <Table.HeaderCell><b>Location</b></Table.HeaderCell>
                        <Table.Cell dataKey="parentType"></Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={2} minWidth={125} sortable>
                        <Table.HeaderCell><b>File Name</b></Table.HeaderCell>
                        <Table.Cell dataKey="file">{(rowData) => (<a style={{ color: 'blue', cursor: 'pointer' }} onClick={() => { attachmentService.openFile(rowData.id) }}>{rowData.file}</a>)}</Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={2} minWidth={125} sortable>
                        <Table.HeaderCell><b>Doc Type</b></Table.HeaderCell>
                        <Table.Cell dataKey="attachmentType"></Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={1} minWidth={75} sortable>
                        <Table.HeaderCell><b>Date Created</b></Table.HeaderCell>
                        <Table.Cell dataKey="timestamp">{rowData => (new Date(rowData.timestamp).toLocaleDateString())}</Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={1} minWidth={50} sortable>
                        <Table.HeaderCell><b>Laserfiche ID</b></Table.HeaderCell>
                        <Table.Cell dataKey="laserficheId"></Table.Cell>
                    </Table.Column>
                </Table>
                <Button className="mt-2" disabled={checkedRows?.length == 0} onClick={downloadSelected}>Download Selected</Button>
            </div>
            :
            <LoadingSpinner />
        }
    </>;
}


export default EntityEnforcementAttachments;